import { Button, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { InputSelect } from '../../../../../commonComponents';

import { useRate } from '../../hooks/useRate';
import { CollapsibleRow } from '../CollapsibleRow/CollapsibleRow';
import { Title } from '../CollapsibleRow/Title';
import { Value } from '../CollapsibleRow/Value';
import { OutlineDollarCircleIcon } from '@tempmee/react-icons';

/**
 * @deprecated Use InputJob.HourlyRate from ~/commonComponents instead.
 * This component will be removed in a future version.
 */
export const HourlyRateRow = forwardRef(
  ({ onToggle, isOpen, defaultValue, onConfirm, averagePrice }, ref) => {
    const {
      selectedRate,
      setOfferRate,
      industrialAverageColor,
      industrialAverageIcon,
      getWarningMessage,
      disabledBtn,
      rates,
    } = useRate({ averagePrice, defaultValue });

    return (
      <CollapsibleRow
        dataTestId="hourly-rate-row"
        dataCy="hourly-rate-row"
        ref={ref}
        isOpen={isOpen}
        onToggle={onToggle}
        TitleComponent={() => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Title text="Hourly Rate:" />
          </div>
        )}
        ValueComponent={() => (
          <Value
            customStyles={{
              color: isOpen || !defaultValue ? colors.neutral[300] : colors.neutral[600],
            }}
            text={!isOpen && defaultValue ? `$${defaultValue}` : '$--.--'}
          />
        )}
        icon={<OutlineDollarCircleIcon size={24} color={colors.secondary[500]} />}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginLeft: 60,
            marginRight: 60,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 20,
              gap: 12,
              width: 200,
            }}
          >
            <b
              style={{
                fontFamily: 'Nunito',
                fontSize: 24,
                color: colors.neutral[600],
              }}
            >
              $
            </b>

            <InputSelect
              dataTestId="hourly-rate-input"
              dataCy="hourly-rate-input"
              value={selectedRate}
              setValue={setOfferRate}
              options={rates.map((item) => ({
                title: `${item}.00`,
                value: `${item}.00`,
              }))}
            />
          </div>

          <div
            data-testid="rate-status-indicator"
            data-cy="rate-status-indicator"
            style={{ display: 'flex', width: '100%', justifyContent: 'center' }}
          >
            <motion.span
              key={industrialAverageColor}
              style={{ display: 'flex', marginRight: 6 }}
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              {industrialAverageIcon[industrialAverageColor]}
            </motion.span>

            {getWarningMessage()}
          </div>

          <Typography
            italic
            color={colors.neutral[500]}
            style={{ fontSize: 15, textAlign: 'center', marginBottom: 28, marginTop: 12 }}
          >
            Our average hourly rate is based on statewide data, and may not precisely reflect rates
            in your local area.
          </Typography>

          <Button
            variant="secondary"
            size="md"
            onClick={() => {
              onConfirm(selectedRate);
            }}
            disabled={disabledBtn}
            data-testid="confirm-hourly-rate"
            data-cy="confirm-hourly-rate"
          >
            Confirm
          </Button>
        </div>
      </CollapsibleRow>
    );
  },
);
